import { ACP_ELIGIBLE_INSURERS } from "@/core/constants";

/**
 * Determines if a patient is eligible for ACP (Advance Care Program) features
 * based on their primary insurance carrier.
 *
 * Patients with certain insurers (Other, CDPHP, MVP) are eligible for ACP features
 * including the Consents menu item.
 */
export function isACPEligibleCarrier(carrier: string) {
  return (ACP_ELIGIBLE_INSURERS as readonly string[]).includes(carrier);
}
